import React, { useRef, useState, useEffect } from 'react';
import CarouselCard from '../../../components/molecules/CarouselCard';
import Box from '../../../components/molecules/Box';
import useStyles from './style';
import { Helmet } from 'react-helmet';
import Slider from 'react-slick';
import { analyticsData } from '../../../../../src/constants/Analytics/analytics-data';
import { createDynamicLabels } from '../../../../utils/analytics';
import { get } from 'lodash';
import { useTheme } from '@material-ui/core/styles';
import { settings } from './config';
import { pushAnaylyticsData } from '../../../../../src/utils/analytics';
import { useMediaQuery } from '@material-ui/core';
import { EVENT_TYPE } from '../../../../constants';
import { getRedirectionUrl } from '../../../utils/getRedirectionUrl';

const AdCalenderCarousel = (props) => {
  const { result, componentName, pageName, language, title, customADStyle = false } = props
  const [pauseAnalytics, setPauseAnalytics] = useState(true)
  const theme = useTheme();
  const classes = useStyles(props);
  const hasFavouriteBasket = true
  const sliderRef = useRef(null);
  const mainElementRef = useRef(null);
  const isRTL = theme && theme.direction === 'rtl';
  const contentType = get(
    props,
    'sitecoreContext.route.fields.contentType.fields.taxonomyKey.value',
    ''
  ).toLowerCase();

  useEffect(() => {
    if (result && result.length > 0 && isRTL) {
      result.reverse();
    }
  }, [])

  // Reverse carouselItems sequence if RTL is true

  const isMobile = () => {
    const ua = navigator.userAgent;

    return ((/Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua) || 'ontouchstart' in document) && window.innerWidth < 1024);
  }
  useEffect(() => {
    if (isRTL && !isMobile() && result.length > 0) {
      setTimeout(() => {
        sliderRef.current.slickGoTo(sliderRef.current.props.children.length);
      }, 2000);
      setTimeout(() => {
        setPauseAnalytics(false)
      }, 2200)
    }
  }, [result]);
  let slickSettings = {
    ...settings,
  };

  // Conditionally add the responsive settings
  if (customADStyle) {
    slickSettings.responsive = [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1,
          centerPadding: customADStyle ? '33px' : '0px',
          arrows: false,
          useTransform: false,
          useCSS: false,
          touchMove: false,
          rtl: false,
        },
      },
    ];
  }

  const slide_fix = () => {
    // click slide slick-next button till its disabled, after every 500ms
    if (mainElementRef && mainElementRef.current) {
      const slickNextBtn = mainElementRef.current.querySelector('.slick-next');
      // if arrows dont exists then show main element
      if (!slickNextBtn) {
        mainElementRef.current.style.opacity = 1;
        mainElementRef.current.style.pointerEvents = 'auto';
        return
      }
      if (slickNextBtn && slickNextBtn.classList.contains('slick-disabled')) {
        // enable main element
        mainElementRef.current.style.opacity = 1;
        mainElementRef.current.style.pointerEvents = 'auto';
        return
      }
      if (slickNextBtn && !slickNextBtn.classList.contains('slick-disabled')) {
        slickNextBtn.querySelector('button').click();
        setTimeout(() => {
          slide_fix();
        }, 600);
      } else {
        setTimeout(() => {
          slide_fix();
        }, 600);
      }
    }
  }

  const initSlider = () => {
    if (isRTL) {
      const carouselLen = result?.length ? result.length : 0

      // if carousel length is > 3 & settigns have arrows enabled
      if (carouselLen > 3 && settings.arrows) {
        // disable main element
        mainElementRef.current.style.opacity = 0;
        mainElementRef.current.style.pointerEvents = 'none';
      }

      setTimeout(() => {
        sliderReady();
      }, 600);
    }
  };

  const sliderReady = () => {
    if (sliderRef && sliderRef.current) {

      sliderRef.current.slickGoTo(0);
      setTimeout(() => {
        slide_fix();
      }, 600);
    } else {
      setTimeout(() => {
        sliderReady();
      }, 600);
    }
  };
  const addSwipeAnalyticsInfo = () => {
    if (pauseAnalytics && isRTL) return
    const obj = {
      ...analyticsData.pageBodyInteraction.swipeArrowClick,
      ...{
        label: createDynamicLabels([
          pageName,
          componentName,
          `${title && title.value}`,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };
  return (
    <Box className={`${classes.root}`}>
      <Box component="div" className={`${classes.collageItems} ${isRTL ? classes.rtlClass : ""}${Array.isArray(result) && result.length < 3 ? " hasLessThan3Items" : ""} ${Array.isArray(result) && result.length === 3 ? " has3Items" : ""} adCalenderWrapper`}>
        <Slider
          afterChange={() => addSwipeAnalyticsInfo()}
          {...slickSettings}
          onInit={initSlider}
          ref={sliderRef}
        >
          {result &&
            result.map(item => (
              <React.Fragment key={item}>
                <CarouselCard
                  isAdCard={true}
                  sectionTitle={get(item, 'name', '')}
                  title={get(item, 'name', '')}
                  desktopImage={get(item, 'thumbnailImage', '')}
                  mobileImage={get(item, 'thumbnailImage', '')}
                  ctaLink={get(item, 'itemUrl', [])}
                  imageCtaUrl={
                    contentType === EVENT_TYPE
                      ? getRedirectionUrl(item, language)
                      : get(item, 'itemUrl', '')
                  }
                  startDate={get(item, 'startDate', '')}
                  locationTitle={get(item, 'location_Titles[0]', '')}
                  region={get(item, 'location_Regions[0]', '')}
                  endDate={get(item, 'endDate', '')}
                  openTime={get(item, 'openTime', '')}
                  closeTime={get(item, 'closeTime', '')}
                  videoDesktop={get(item, 'videoDesktop', '')}
                  videoMobile={get(item, 'videoMobile', '')}
                  umbrellaEventCount={get(
                    item,
                    'umbrellaEventCount',
                    ''
                  )}
                  eventType={get(item, 'eventType', '')}
                  cardType={'event'}
                  language={language}
                  pageName={pageName}
                  urlSlug={get(item, 'urlSlug', '')}
                  itemUniqueKey={get(item, 'itemUniqueKey', '')}
                  showFavoriteIcon={hasFavouriteBasket}
                  lazyLoading={true}
                  componentName={componentName}
                  eventCategories={get(item, 'eventCategories', [])}
                />
              </React.Fragment>
            ))}
        </Slider>
      </Box>
    </Box>
  );
}

export default AdCalenderCarousel;
